import { z } from 'zod'

// response schema for the public GET /auth/registration-status endpoint
export const registrationStatusResponseSchema = z.object({
  allowed: z.boolean(),
})

export type RegistrationStatusResponseDto = z.infer<typeof registrationStatusResponseSchema>
